<div
    class="bazis-map"
    #mapElement
    [class.bazis-map_grayscale]="tileMode === 'grey'"
></div>
<ng-container
    *ngIf="{
        settings: settings$ | async,
        map: map$ | async,
    } as data"
>
    <ng-container *ngIf="data.map">
        <div class="bazis-map__base-control bazis-map__base-control_top">
            <ng-content select="[top]"></ng-content>
        </div>
        <div class="bazis-map__base-control">
            <bazis-map-open-modal-control
                *ngIf="openModalControlEnabled"
                [mapSettings$]="settings$"
                [mapLayers$]="layers$"
                [mapPopupInfo$]="popupInfo$"
            ></bazis-map-open-modal-control>

            <bazis-map-tiles-control
                *ngIf="tileControlEnabled && data.settings.tiles?.length > 1"
                [tiles]="data.settings.tiles"
                [selectedTileId]="selectedTileId"
                (setTileLayer)="setTileLayer($event)"
            ></bazis-map-tiles-control>

            <bazis-map-zoom-control
                *ngIf="zoomControlEnabled"
                [map]="data.map"
                fillButton="solid"
            ></bazis-map-zoom-control>

            <app-map-lasso-control
                *ngIf="lassoEnabled"
                [map]="data.map"
                (selected)="lassoSelected.emit($event)"
            ></app-map-lasso-control>

            <app-draw-polygon-control
                *ngIf="drawPolygonEnabled"
                [map]="data.map"
            ></app-draw-polygon-control>

            <app-draw-line-control
                *ngIf="drawLineEnabled"
                [map]="data.map"
            ></app-draw-line-control>

            <app-draw-transform-control
                [map]="data.map"
                [transformSettings]="transformSettings"
                *ngIf="transformEnabled"
            ></app-draw-transform-control>
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="executeFitLayersBounds$ | async"></ng-container>
<!--<ng-container *ngIf="mapGroupSelected$ | async"></ng-container>-->
<ng-container *ngIf="mapSelected$ | async"></ng-container>
<ng-container *ngIf="popupActions$ | async"></ng-container>
<ng-container *ngIf="select$ | async"></ng-container>
<ng-container *ngIf="dragged$ | async"></ng-container>
<ng-container *ngIf="centerOnCoordinates$ | async"></ng-container>
<ng-container *ngIf="resized$ | async"></ng-container>
<ng-container *ngIf="layers$ | async"></ng-container>
